import React from 'react';
import Landing from './component/Landing/Landing';
import Form from './component/Forrm/Form';
import Login from './component/Login/Login';


import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

const Page404 = () =>{
  return(
    <h2>Please Select a currency</h2>
  )
}

function App() {
  return (
    <Router>
          <Switch>
            <Route exact path='/' component={Login}/>
            <Route exact path='/landing' component={Landing}/>
            <Route exact path='/:type/:currency/:unit/' component={Form}/>
            <Route component={Page404}/>
          </Switch>
    </Router>
    
  );
}

export default App;